import { KellyDarkTheme } from "../.internal/themes/KellyDarkTheme";
export default KellyDarkTheme;
